// types
export const Types = {
  REQUEST_CONTACT_FORM_UPDATE: "REQUEST_CONTACT_FORM_UPDATE"
};

export function updateContact(parameters) {
  return { type: Types.REQUEST_CONTACT_FORM_UPDATE, payload: parameters };
}
